import { render, staticRenderFns } from "./ImportPopup.vue?vue&type=template&id=67fba1ef&scoped=true"
import script from "./ImportPopup.vue?vue&type=script&lang=js"
export * from "./ImportPopup.vue?vue&type=script&lang=js"
import style0 from "./ImportPopup.vue?vue&type=style&index=0&id=67fba1ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fba1ef",
  null
  
)

export default component.exports